import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { LatestResultIconsBlue, LatestResultIconsDesktop } from 'src/app/models/app-constants';

@Component({
  selector: 'app-site-rating',
  templateUrl: './site-rating.component.html',
  styleUrls: ['./site-rating.component.scss']
})
export class SiteRatingComponent implements OnChanges {
	@Input() rating : number | undefined;
	@Input() useBlueIcons : boolean = true;
	//@Input() iconSource : string;
	starRatingIcon : string = "";
	starRatingText : string = ""
	


	ngOnChanges(changes: SimpleChanges): void {

		const starRating = changes["rating"].currentValue;
		switch(starRating)
		{
			case 1 :
				//this.starRatingIcon = mobile ? LatestResultIconsMobile.get("Bad")! : LatestResultIconsDesktop.get("Bad")!;
				this.starRatingIcon = !this.useBlueIcons ? LatestResultIconsDesktop.get("Bad")! : LatestResultIconsBlue.get("Bad")!;
				this.starRatingText = "Bad";
				break;
			case 2 :
				this.starRatingIcon = !this.useBlueIcons ?LatestResultIconsDesktop.get("Poor")! : LatestResultIconsBlue.get("Poor")!;	
				this.starRatingText = "Poor";			
				break;
			case 3: 
				this.starRatingIcon = !this.useBlueIcons ? LatestResultIconsDesktop.get("Ok")! : LatestResultIconsBlue.get("Ok")!;
				this.starRatingText = "Fair";			
				break;
			case 4 :
				this.starRatingIcon =  !this.useBlueIcons ?LatestResultIconsDesktop.get("Good")! : LatestResultIconsBlue.get("Good")!;	
				this.starRatingText = "Good";			
				break;
			default : 
				this.starRatingIcon = "";
				this.starRatingText = "No result"
				break;
		}

		
	}

 
}
